var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-choose-wrapper"},[_c('calendar',{attrs:{"initial":"1"},on:{"choose":_vm.chooseDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }